var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from '@apollo/client';
import useScroll from 'utils/hooks/useScroll';
import { getPageInfo } from 'utils/paginationHelper';
import ORGANIZATION_GROUPS from 'apollo/queries/ORGANIZATION_GROUPS';
var useOrganizationGroupsTable = function (_a) {
    var _b;
    var filterValues = _a.filterValues, id = _a.id, containerRef = _a.containerRef;
    var variables = {
        filters: __assign({ team_ids: [id] }, filterValues)
    };
    var _c = useQuery(ORGANIZATION_GROUPS, {
        variables: variables
    }), data = _c.data, loading = _c.loading, fetchMore = _c.fetchMore;
    var dataSource = ((_b = data === null || data === void 0 ? void 0 : data.organization_groups) === null || _b === void 0 ? void 0 : _b.nodes) || [];
    var dataPath = ['organization_groups'];
    var pageInfo = getPageInfo(dataPath)(data);
    var scrollLoading = useScroll({
        dataPath: dataPath,
        dataType: 'nodes',
        fetchMore: fetchMore,
        pageInfo: pageInfo,
        isTable: true,
        filterUniqueIds: true,
        tableId: '',
        scrollRef: containerRef,
        isHorizontalScroll: false
    }).scrollLoading;
    return {
        data: {
            loading: loading,
            organizationGroups: dataSource,
            scrollLoading: scrollLoading
        }
    };
};
export default useOrganizationGroupsTable;
